<template>
  <div class="yqfx">
    <van-nav-bar
        title="用气分析"
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
    />

    <div class="margin0"/>

    <van-cell v-model="C_Code" icon="user-circle-o" size="large" >
      <!-- 使用 title 插槽来自定义标题 -->
      <template #title>
        <span class="custom-title">{{C_Name}}</span>
      </template>
    </van-cell>
    <van-cell  icon="wap-home-o">
      <template #title>
        <span class="custom-title2">{{C_Address}}</span>
      </template>
    </van-cell>

    <div class="margin1"/>

    <van-tabs v-model="active">
      <van-tab title="日用气量">

        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
          <van-list
              v-model="loading"
              :finished="finished"
              finished-text="没有更多了"
              @load="onLoad"
          >
            <van-cell-group v-for="(item) in list" :key="item.id"  >
              <van-cell  v-model="item.myDate" icon="calendar-o" size="large">
                <!-- 使用 title 插槽来自定义标题 -->
                <template #title>
                  <span class="custom-title">用气日期  </span>
                </template>
              </van-cell>
              <van-cell title="用气量（m³）" v-model="item.myAmount" icon="bar-chart-o"/>
            </van-cell-group>

          </van-list>
        </van-pull-refresh>
      </van-tab>

      <van-tab title="月用气量">
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
          <van-list
              v-model="loading"
              :finished="finished"
              finished-text="没有更多了"
              @load="onLoad"
          >
            <van-cell-group v-for="(item) in list1" :key="item.id"  >
              <van-cell  v-model="item.myMonth" icon="calendar-o" size="large">
                <!-- 使用 title 插槽来自定义标题 -->
                <template #title>
                  <span class="custom-title">用气月份  </span>
                </template>
              </van-cell>
              <van-cell title="用气量（m³）" v-model="item.myAmount" icon="bar-chart-o"/>
            </van-cell-group>

          </van-list>
        </van-pull-refresh>
      </van-tab>

    </van-tabs>





  </div>
</template>
<script>
import API from './../api/index';
import {Toast} from "vant";

export default {
  name: 'page_yqjl',
  data() {
    return {
      C_ID:"",
      C_Code:"",
      C_Name:"",
      C_Address:"",
      list: [],
      list1: [],
      loading: false,
      finished: false,
      refreshing: false,
      index:""
    }
  },
  methods: {
    onClickLeft(){
      this.$router.go(-1);
    },
    getCust() {
      if (this.$cookie.get('CID')===''||!this.$cookie.get('CID')) {
        Toast('请先绑定用户！')
        this.$router.push('/bindlist');
      } else {
        this.C_ID=this.$cookie.get('CID');
        this.C_Code=this.$cookie.get('C_Code');
        this.C_Address=this.$cookie.get('CAddress');
        this.C_Name=this.$cookie.get('CName');
      }

    },
    onLoad() {
      setTimeout(() => {
        if (this.refreshing) {
          this.list = [];
          this.refreshing = false;
        }

        this.$http.get(API.LookUserDayGas,{
          params: {
            c_id:this.C_ID
          }
        })
            .then((response)=>{
              let res = response.data;
              if (res.code == 0) {
                this.list=res.subdata;
              } else {
                this.loading = false;
                this.finished= true;
              }
            });

        this.$http.get(API.LookUserMonthGas,{
          params: {
            c_id:this.C_ID
          }
        })
            .then((response)=>{
              let res = response.data;
              if (res.code == 0) {
                this.list1=res.subdata;
              } else {
                this.loading = false;
                this.finished= true;
              }
            });

        this.loading = false;

        if (this.list.length) {
          this.finished = true;
        }
      }, 1000);
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.onLoad();
    }
  },
  mounted () {
    this.getCust();
  }
}
</script>
<style>
.index{
  height: 100vh;
  background-color: #f5f5f5;
}
.margin1{
  height: 0.5rem;
  background-color: #f5f5f5;
}
.margin0{
  height: 0.5rem;
  background-color: #f5f5f5;
}
.custom-title {
  margin-right: 4px;
  vertical-align: middle;
}

</style>